import type { EntryStatus, JobStatus, Role } from '@siteday/shared';
import { AlertTriangle, Check, Lock, Pencil, RefreshCw } from 'lucide-react';

import { Pill, type PillTone } from '@/components/ui/badge';

const entryMeta: Record<EntryStatus, { tone: PillTone; label: string; icon: typeof Check }> = {
  draft: { tone: 'neutral', label: 'Draft', icon: Pencil },
  finished: { tone: 'good', label: 'Finished', icon: Check },
  synced: { tone: 'good', label: 'Synced', icon: RefreshCw },
  needs_review: { tone: 'bad', label: 'Needs review', icon: AlertTriangle },
  approved: { tone: 'info', label: 'Approved', icon: Lock },
};

export function EntryStatusPill({
  status,
  className,
}: {
  status: EntryStatus;
  className?: string | undefined;
}) {
  const m = entryMeta[status];
  const Icon = m.icon;
  return (
    <Pill tone={m.tone} className={className} data-status={status}>
      <Icon />
      {m.label}
    </Pill>
  );
}

const jobTone: Record<JobStatus, PillTone> = {
  active: 'good',
  bidding: 'warn',
  complete: 'neutral',
};

export function JobStatusPill({ status }: { status: JobStatus }) {
  return <Pill tone={jobTone[status]}>{status}</Pill>;
}

const roleTone: Record<Role, PillTone> = {
  owner: 'neutral',
  admin: 'neutral',
  foreman: 'info',
  worker: 'neutral',
};

export function RolePill({ role }: { role: Role }) {
  if (role === 'worker') return <span className="capitalize">Worker</span>;
  return <Pill tone={roleTone[role]}>{role}</Pill>;
}
